<template>
  <div class="heavy-currency">
    <div class="currency-top-bk">
      <div>
        <VillagesTopNav
          imgSrc="white"
          :borderShow="false"
          :options="{navColor:'#fff',bgColor:'transparent',borderWidth:'0px'}"
          @leftIconFun="()=>{this.$router.go(-1);}"
        >
          <h2 slot="content">重消币</h2>
        </VillagesTopNav>
        <div class="chong-zhi">
          <p class="currency-font">重消币余额</p>
          <p class="currency-price">
            <span></span>{{personal.consum_point}}
          </p>
          <router-link :to="{path:'/investCurrency'}">
            <div class="currency-btn">充值</div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="shouzhi-list">
      <p class="shouzhi-list-title">收支明细</p>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="5"
        :immediate-check="false"
        @load="onLoad()"
      >
        <div class="pay-records-list">
          <payDetails :data="data"></payDetails>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import VillagesTopNav from "../../components/VillagesTopNav.vue";
import payDetails from "../../components/payDetails.vue";
export default {
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      page_no: 1,
      page_size: 10,
      personal:{}
    };
  },
  components: {
    VillagesTopNav,
    payDetails
  },
  created() {
    this.getdata();
    this.infoData();
  },
  methods: {
    infoData(){
      this.getRequest( `members`).then(res => {
       this.personal = res.data.data;
      })
    },
    onLoad() {
      this.page_no = this.page_no + 1;
      this.getdata();
    },
    getdata() {
      this.getRequest(`members/points`, {
        page_no: this.page_no,
        page_size: this.page_size
      }).then(res => {
        if (res.data.code == 1) {
          this.typeCount = [];
        } else {
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
          this.data = this.data.concat(res.data.data.data);
        }
      });
    }
  }
};
</script>
<style scoped>
.heavy-currency {
  background-color: #fff;
  min-height: 100vh;
}
.shouzhi-list-title {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 42px;
  margin-top: 37px;
  margin-bottom: 25px;
  padding-left: 30px;
}
.shouzhi-list {
  background: rgba(255, 255, 255, 1);
  /* box-shadow:0px 8px 20px 0px rgba(0,0,0,0.05); */
  border-radius: 40px 40px 0 0;
  /* padding: 0px 30px; */
  overflow: hidden;
}
.currency-top-bk {
  width: 750px;
  height: 632px;
  background: linear-gradient(360deg, #f5f5f5 36%, rgba(206, 16, 3, 1) 100%);
  background-color: #fbfbfb;
  overflow: hidden;
}
.currency-top-bk > div {
  width: 750px;
  height: 385px;
  background: url("../../assets/img/icon/currencybk.png");
  background-size: 100% 100%;
  /* background-color: #FBFBFB; */
}
.currency-top-bk h2 {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 50px;
}
.chong-zhi {
  width: 694px;
  height: 460px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  margin: 30px auto 0px;
  overflow: hidden;
}
.currency-font {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 40px;
  width: 100%;
  text-align: center;
  margin-top: 86px;
}
.currency-price {
  font-size: 62px;
  margin: 12px auto 74px;
  width: 100%;
  text-align: center;
  font-weight: 600;
}
.currency-price > span {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 1);
  line-height: 42px;
}
.currency-btn {
  width: 426px;
  height: 94px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 32px;
  background: url("../../assets/img/icon/currencybtn.png");
  background-size: 100% 100%;
  margin: 0 auto;
}
</style>